module.exports = __webpack_public_path__ + "img/icon_jingxingzhong@2x.b143196f.png";